var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLesson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.2852,
    cy: 12,
    r: 12,
    fill: "#8954E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2852 13.5C14.2182 13.5 15.7852 11.933 15.7852 10C15.7852 8.067 14.2182 6.5 12.2852 6.5C10.3522 6.5 8.78516 8.067 8.78516 10C8.78516 11.933 10.3522 13.5 12.2852 13.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2852 4.5C11.1527 4.49957 10.0477 4.84887 9.12118 5.50018C8.1947 6.15149 7.49197 7.07301 7.10902 8.1388C6.72607 9.20459 6.68159 10.3626 6.98167 11.4547C7.28174 12.5467 7.91173 13.5194 8.78552 14.2398V19C8.78551 19.0852 8.80729 19.1691 8.8488 19.2435C8.8903 19.3179 8.95015 19.3806 9.02265 19.4254C9.09516 19.4702 9.17792 19.4957 9.26306 19.4995C9.34821 19.5033 9.43292 19.4853 9.50915 19.4472L12.2851 18.059L15.0619 19.4472C15.1382 19.4853 15.2229 19.5033 15.308 19.4995C15.3932 19.4957 15.4759 19.4701 15.5484 19.4253C15.6209 19.3805 15.6807 19.3179 15.7222 19.2435C15.7637 19.169 15.7855 19.0852 15.7855 19V14.2392C16.6591 13.5187 17.2889 12.5459 17.5888 11.454C17.8887 10.362 17.8441 9.20403 17.4611 8.13835C17.0781 7.07267 16.3754 6.15126 15.4489 5.50004C14.5225 4.84882 13.4176 4.49956 12.2852 4.5ZM12.2852 14.5C11.3951 14.5 10.5251 14.2361 9.78509 13.7416C9.04507 13.2471 8.46829 12.5443 8.1277 11.7221C7.7871 10.8998 7.69799 9.99501 7.87162 9.12209C8.04526 8.24918 8.47384 7.44736 9.10318 6.81802C9.73251 6.18868 10.5343 5.7601 11.4072 5.58647C12.2802 5.41283 13.185 5.50195 14.0072 5.84254C14.8295 6.18314 15.5323 6.75991 16.0268 7.49993C16.5212 8.23996 16.7852 9.10998 16.7852 10C16.7838 11.1931 16.3093 12.3369 15.4657 13.1805C14.622 14.0241 13.4782 14.4987 12.2852 14.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLesson);
export default __webpack_public_path__ + "static/media/lesson.eb065441.svg";
export { ForwardRef as ReactComponent };